import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAE8AjjXQxxCrsnXmjyTomQjtaBAMTLoS0",
  authDomain: "jowlary-19531.firebaseapp.com",
  projectId: "jowlary-19531",
  storageBucket: "jowlary-19531.firebasestorage.app",
  messagingSenderId: "494690893504",
  appId: "1:494690893504:web:5cba67b03c882390f27725",
  measurementId: "G-B6J3KXZWX1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
